import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { Clock, Crown, AlertTriangle } from "lucide-react";
import { useAuth } from "@/context/AuthContext";
import api from "@/lib/api";

export function TrialBanner() {
  const { user } = useAuth();
  const [s, setS] = useState(user?.subscription_state || null);

  useEffect(() => {
    api.get("/subscription").then(({ data }) => setS(data)).catch(() => {});
  }, []);

  if (!s || s.plan !== "trial") return null;

  if (s.expired) {
    return (
      <div data-testid="trial-banner-expired" className="mx-4 mt-4 rounded-2xl bg-rose-50 border border-rose-200 p-4">
        <div className="flex items-start gap-3">
          <div className="w-9 h-9 rounded-xl bg-rose-500 text-white grid place-items-center shrink-0"><AlertTriangle className="w-4.5 h-4.5" /></div>
          <div className="min-w-0">
            <p className="font-display font-bold text-rose-900 leading-tight">La tua prova gratuita è terminata</p>
            <p className="text-sm text-rose-700 mt-0.5">Le tue guide pubbliche sono in pausa. Passa a un piano per riattivarle.</p>
            <Link to="/dashboard/billing" data-testid="trial-banner-upgrade" className="mt-3 inline-flex items-center gap-1.5 bg-rose-600 text-white text-sm font-semibold rounded-full px-4 py-2">
              <Crown className="w-4 h-4" /> Scegli un piano
            </Link>
          </div>
        </div>
      </div>
    );
  }

  const days = s.days_remaining ?? 0;
  return (
    <div data-testid="trial-banner" className="mx-4 mt-4 rounded-2xl bg-blue-50 border border-blue-100 p-4">
      <div className="flex items-center gap-3">
        <div className="w-9 h-9 rounded-xl bg-blue-500 text-white grid place-items-center shrink-0"><Clock className="w-4.5 h-4.5" /></div>
        <div className="flex-1 min-w-0">
          <p className="font-display font-bold text-blue-900 leading-tight">
            {days > 0 ? `${days} ${days === 1 ? "giorno" : "giorni"} di prova rimanenti` : "Ultimo giorno di prova"}
          </p>
          <p className="text-xs text-blue-700/80 mt-0.5">Sblocca strutture, foto e AI illimitati con Pro.</p>
        </div>
        <Link to="/dashboard/billing" data-testid="trial-banner-upgrade" className="shrink-0 inline-flex items-center gap-1.5 bg-blue-600 text-white text-sm font-semibold rounded-full px-4 py-2">
          <Crown className="w-4 h-4" /> Passa a Pro
        </Link>
      </div>
    </div>
  );
}
